<script>
import {mapActions} from "vuex";

export default {
  name: "VideoPauseMixin",
  data() {
    return {}
  },
  created () {
    // console.log('# %s created', this.$options.name);
    try{
      this.pauseMyVideo({pauseText: 'Setting'})
    }catch(e){
      console.error(e);
    }
  },
  beforeDestroy() {
    // console.log('# %s beforeDestroy', this.$options.name);
    try{
      this.resumeMyVideo()
    }catch(e){
      console.error(e);
    }
  },
  methods: {
    ...mapActions('call', ['pauseMyVideo', 'resumeMyVideo'])
  }
}
</script>
